import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';

import { PostoService } from '../services/posto.service';
import { ExcelService } from '../services/excel.service';
import Swal from 'sweetalert2';

import { ActivatedRoute, Router } from "@angular/router";
import { PerfilUsuarioService } from '../services/perfil-usuario.service';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-posto',
  templateUrl: './posto.component.html',
  styleUrls: ['./posto.component.css'],
  animations: [loadingFade, modal, alert]
})
export class PostoComponent implements OnInit {

  	public loading = false;
	public postos = [];
	public bairro_array = [];

	// paginacao
	public page = 1;
	public limit = 10;
  	public count = 0;

	//acesso
	public menu_id = 126; //Cadastro - ADM
	public usuario_perfil;
	public visualizar = true;
	public editar = false;		
  
	constructor(private postoSvc: PostoService,
				private excelSvc: ExcelService,
				private route: ActivatedRoute,
				private perfilUsuarioSvc: PerfilUsuarioService,
				private authSvc: AuthService) { }

	ngOnInit() {


		//Verifica Permissões Acesso
		this.usuario_perfil = this.authSvc.getPerfil();
		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].editar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		}); 

		this.pegaPostos();
	}

  	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	pegaPostos(){
		this.postos = [];
		this.loading = true;
		this.postoSvc.getPostos().then((data: any[]) => {
			this.postos = data;
			this.count = this.postos.length;
			for(let index in this.postos){
				this.postos[index]['address'] = this.postos[index].posto_endereco +
				' n.' + this.postos[index].posto_endereco_numero + ', ' +
				this.postos[index].bairro.bairro_nome + ', ' +
				this.postos[index].municipio.municipio_nome + ', ' +
				this.postos[index].uf.uf_nome;
			}
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		})
	}

	apagaPosto(id) {
		Swal.fire({
			type:'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'
			  
		}).then((result) => {
			if(result.value == true){
				this.postoSvc.apagaPosto(id).then((data) => {
					this.pegaPostos();
					Swal.fire({
						type: 'success',
						title: 'Apagado com sucesso!'
					});
				}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
		})
	}

	exportarExcel(){
		let data = [];
		for(let index in this.postos){
			data[index] = {
				'Posto': this.postos[index].posto_nome,
				'Endereço': this.postos[index].posto_endereco +
							' n.' + this.postos[index].posto_endereco_numero + ', ' +
							this.postos[index].bairro.bairro_nome + ', ' +
							this.postos[index].municipio.municipio_nome + ', ' +
							this.postos[index].uf.uf_nome,
				'CEP': this.postos[index].posto_cep,
				'CNPJ': this.postos[index].posto_cnpj
			};
		}

		this.excelSvc.exportAsExcelFile(data, 'Chronos Frota - Postos de Combustível');
	}
}
